<template>
  <div class="mb-2">
    <div class="flex items-center justify-between gap-4 rounded-[15px] bg-gray-10 px-4 py-2">
      <div class="flex items-center gap-9">
        <div>{{ booking.LocationName }} - {{ booking.GroupName }}</div>
        <div>
          {{ niceDateFormat(booking.StartTimeStamp) }}
          {{ formatTime(booking.StartTimeStamp, 0) }} -
          {{ formatTime(booking.StartTimeStamp, booking.LengthMinutes) }}
        </div>
      </div>
      <Button
        variant="danger"
        v-on:click="showModal.unbook = true"
        @keyup.enter="
          showModal.unbook = true;
          $event.preventDefault();
          $event.stopPropagation();
        "
        tabindex="0"
      >
        Avboka
        <template #icon-after>
          <IconTrashCan />
        </template>
      </Button>
    </div>

    <!-- Fel vid "Du har nåt max antal bokningar per tvättstuga" -->
    <Modal
      v-if="showModal.cantUnbookStartedTime"
      cancelText="Stäng"
      v-on:cancel="showModal.cantUnbookStartedTime = false"
    >
      <div>Du kan inte avboka en tvätttid som pågår eller passerat</div>
    </Modal>

    <!-- Bekräfta att man vill avboka -->
    <Modal
      v-if="showModal.unbook"
      cancelText="Nej"
      confirmText="Ja, Avboka"
      v-on:confirm="
        cancelBooking();
        showModal.unbook = false;
      "
      v-on:cancel="showModal.unbook = false"
    >
      <p class="text-t5 text-center">
        Vill du avboka
        <strong>{{ startTimeFormated }} - {{ endTimeFormated }}, {{ dateFormated }}</strong>
        ?
      </p>
    </Modal>

    <!-- Visas när man avbokat tid -->
    <Modal v-if="showModal.unbooked" cancelText="Ok" v-on:cancel="showModal.unbooked = false">
      <p>Din tid är avbokad</p>
    </Modal>

    <!-- Fel vid request modal -->
    <Modal v-if="showModal.error" cancelText="Stäng" v-on:cancel="showModal.error = false">
      <p>Tyvärr, något blev fel</p>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/ui/modal';
import Button from '@/components/ui/button';
import IconTrashCan from '@/components/icons/IconTrashCan';
import dayjs from 'dayjs';

export default {
  name: 'LaundryBookingTile',
  components: { Modal, Button, IconTrashCan },
  props: {
    booking: {
      type: Object,
      requried: true,
    },
  },
  data: function () {
    return {
      showModal: {
        // Visa "Vill du avboka?"
        unbook: false,

        // Visa "Du har avbokat..."
        unbooked: false,

        // Du kan inte avboka en pågående eller passerad tvättid
        cantUnbookStartedTime: false,

        // Visa "Tvärr, något blev fel"
        error: false,
      },
    };
  },
  computed: {
    startTimeHasPast() {
      return dayjs(this.booking.StartTimeStamp).isBefore(new Date());
    },
    startTimeFormated: function () {
      return dayjs(this.booking.StartTimeStamp).format('HH:mm');
    },
    endTimeFormated: function () {
      return dayjs(this.booking.StartTimeStamp)
        .add(this.booking.LengthMinutes, 'minute')
        .format('HH:mm');
    },
    dateFormated: function () {
      return (
        dayjs(this.booking.StartTimeStamp).format('dddd') +
        ' den ' +
        ' ' +
        dayjs(this.booking.StartTimeStamp).format('DD MMMM')
      );
    },
  },
  methods: {
    niceDateFormat(d) {
      return dayjs(d).format('ddd') + ' ' + dayjs(d).format('DD MMM');
    },
    formatTime(time, length) {
      return dayjs(time).add(length, 'minute').format('HH:mm');
    },
    formatDate(dateString) {
      return new Date(dateString).toISOString().split('T')[0];
    },
    cancelBooking: function () {
      if (this.startTimeHasPast) {
        this.showModal.cantUnbookStartedTime = true;
        return;
      }
      // const loader = gavlegardarna.loader.show(document.querySelector('body'), true, true);
      return this.$store
        .dispatch('cancelBooking', this.booking.BookingId)
        .then(() => {
          this.showModal.unbooked = true;
          // gavlegardarna.loader.hide(loader, true);
        })
        .catch((error) => {
          this.showModal.error = true;
          // gavlegardarna.loader.hide(loader, true);
        });
    },
  },
};
</script>
